import {
  getParcel,
  getParcelUpdates,
  toApiError,
} from "@/shared/providers/api";
import type { Paginated, Parcel, ParcelUpdate } from "@/shared/types";
import type { PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeLatest } from "redux-saga/effects";
import { parcelDetailActions, UPDATES_PAGE_SIZE } from "./slice";
import type { LoadUpdatesPayload } from "./types";

function* loadParcel(action: PayloadAction<string>) {
  const vaultId = action.payload;
  try {
    const parcel: Parcel = yield call(getParcel, vaultId);
    yield put(parcelDetailActions.loadParcelSuccess(parcel));
    // The feed is the point of the page, so it starts loading the moment the
    // parcel is known rather than waiting for the container to ask again.
    yield put(parcelDetailActions.loadUpdates({ vaultId, page: 1 }));
  } catch (error) {
    yield put(parcelDetailActions.loadParcelFailure(toApiError(error)));
  }
}

function* loadUpdates(action: PayloadAction<LoadUpdatesPayload>) {
  const { vaultId, page } = action.payload;
  try {
    const data: Paginated<ParcelUpdate> = yield call(
      getParcelUpdates,
      vaultId,
      { page, pageSize: UPDATES_PAGE_SIZE }
    );
    yield put(
      parcelDetailActions.loadUpdatesSuccess({ data, append: page > 1 })
    );
  } catch (error) {
    yield put(parcelDetailActions.loadUpdatesFailure(toApiError(error)));
  }
}

export function* parcelDetailSaga() {
  yield takeLatest(parcelDetailActions.loadParcel.type, loadParcel);
  yield takeLatest(parcelDetailActions.loadUpdates.type, loadUpdates);
}
